import React from "react";

// Lightweight inline icons. They use currentColor (so they recolor with text)
// and have no background — sized to 1em so they scale with font-size.
const base = {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  style: { display: "block" },
};

export function PersonIcon(props) {
  return (
    <svg {...base} {...props}>
      <circle cx="12" cy="8" r="4" />
      <path d="M5 21a7 7 0 0 1 14 0" />
    </svg>
  );
}

export function ChartIcon(props) {
  return (
    <svg {...base} {...props}>
      <path d="M4 4v16h16" />
      <path d="M7 14l3.5-4 3 2.5L20 7" />
    </svg>
  );
}
